var _excluded = ["value", "label", "readonly", "disabled", "children", "className", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useState, useRef } from 'react';
import { combineClasses } from '@okee-uikit/react-utils';
import { usePrefixCls } from '@okee-uikit/react-config';
import { useId } from '@okee-uikit/react-hooks';
import { OptionState, useOption, useSelect } from '../../hooks/select';
import { ListItem } from '../util/ListItem';
export function Option(props) {
  var value = props.value,
      label = props.label,
      readonly = props.readonly,
      disabled = props.disabled,
      children = props.children,
      className = props.className,
      style = props.style,
      extra = _objectWithoutProperties(props, _excluded);

  var select = useSelect();

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      fillback = _useState4[0],
      setFillBack = _useState4[1];

  var id = useId('SelectOption');
  var elemRef = useRef(null);
  var handleSearchQuery = useCallback(function (optionMap) {
    setShow(!!optionMap[id]);
  }, []);
  var handleBackFillUpdate = useCallback(function (backFillId) {
    setFillBack(function (val) {
      var _a, _b;

      if (backFillId === id && !val) {
        (_b = (_a = elemRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView) === null || _b === void 0 ? void 0 : _b.call(_a, {
          block: 'nearest',
          behavior: 'smooth'
        });
        return true;
      }

      if (backFillId !== id && val) {
        return false;
      }

      return val;
    });
  }, []);
  var option = useOption({
    value: value,
    label: label,
    disabled: disabled,
    readonly: readonly
  }, id, handleSearchQuery, handleBackFillUpdate);
  var optionData = option.getData();
  var extraProps = select.getExtraProps() || {};
  var size = extraProps.size || 'md';
  var cls = combineClasses(usePrefixCls('select-option', {
    selected: optionData.selected,
    'fill-back': fillback
  }), className);
  var handleCheckboxChange = useCallback(function (checked) {
    option.setOptionState(checked ? OptionState.SELECTED : OptionState.UNSELECTED);
  }, []);
  var handleItemClick = useCallback(function () {
    var _option$getData = option.getData(),
        optionDisabled = _option$getData.disabled,
        optionReadonly = _option$getData.readonly,
        selected = _option$getData.selected;

    if (!optionDisabled && !optionReadonly) {
      option.setOptionState(selected ? OptionState.UNSELECTED : OptionState.SELECTED);
    }
  }, []);
  return React.createElement("div", {
    ref: elemRef,
    "data-type": "select-option",
    "data-option-id": id,
    className: cls
  }, React.createElement(ListItem, _objectSpread(_objectSpread({}, extra), {}, {
    key: id,
    prefixCls: "select-option",
    checkable: select.multiple && extraProps.checkType === 'checkbox',
    disabled: optionData.disabled,
    readonly: optionData.readonly,
    state: option.getOptionState(),
    onCheckboxChange: handleCheckboxChange,
    onClick: handleItemClick,
    size: size,
    style: _objectSpread(_objectSpread({}, style), {}, {
      display: show ? undefined : 'none'
    }),
    level: option.getOptionIdPath().length
  }), typeof children === 'function' ? children(optionData) : children || label));
}